import React from "react";
import { useEditorStore } from "../../../../../state/editorStore";
import { useActiveSubjectTransform } from "../../../../../hooks/editor/useActiveSubjectTransform";
import styles from "./Rotate.module.css";

const presetAngles = [0, 45, 90];

const Rotate = () => {
  const { rotation, setRotation } = useActiveSubjectTransform();
  const pushSnapshot = useEditorStore((s) => s.pushSnapshot);

  const handleCustom = (e) => {
    const value = Number(e.target.value);

    if (value > 360) return setRotation(360, { recordHistory: false });
    if (value < -360) return setRotation(-360, { recordHistory: false });

    setRotation(value, { recordHistory: false });
  };

  return (
    <div className={styles.container}>
      <p className="subject-section-label">Rotate</p>

      <div className={styles.buttonGroup}>
        {presetAngles.map((angle) => (
          <button
            key={angle}
            className={`${styles.segment} ${
              rotation === angle ? styles.active : ""
            }`}
            onClick={() => setRotation(angle)}
          >
            {angle}°
          </button>
        ))}

        <div className={styles.inputWrapper}>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9-]*"
            value={rotation}
            onChange={handleCustom}
            onFocus={() => pushSnapshot()}
            className={styles.input}
          />
          <span className={styles.degree}>°</span>
        </div>
      </div>
    </div>
  );
};

export default Rotate;
